import React from "react";
import SVG from "react-inlinesvg";
import { LocationInput } from "tsi-common-react/src/apps/common/containers/LocationInput";
import { t } from "ttag";

import iconIconSearch from "../../svg/icon-search.svg";

interface IProps {
    classNames: string;
}

export const PDPModalLocationSearch = (props: IProps): React.ReactNode => {
    const onSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
    };

    const locationInputID = "pdp-modal-location-search-input";
    return (
        <div>
            <form onSubmit={onSubmit}>
                <label
                    className="pdp-modal__label ada-screenreader-only"
                    htmlFor={locationInputID}
                >
                    {t`Location`}
                </label>
                {/* TODO(i18n): Use t tagged template for placeholder: placeholder: t`Your Location` */}
                <LocationInput
                    inputProps={{
                        id: locationInputID,
                        name: "location",
                        placeholder: "Your Location",
                        className: props.classNames,
                    }}
                    inputFormat="short"
                />
                <button
                    className="pdp-modal__search-button"
                    type="submit"
                    aria-label={t`search`}
                >
                    <SVG
                        className="pdp-modal__search-icon"
                        title={t`Search Icon`}
                        aria-labelledby="title"
                        src={iconIconSearch}
                    />
                </button>
            </form>
        </div>
    );
};
